import { NgModule } from '@angular/core';

import { AutoResizeDirective } from './auto-resize.directive';

const COMPONENTS = [
  AutoResizeDirective,
];

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
})

export class AutoResizeDirectiveModule { }
